import axios from "axios"

export default{
    getStatus(code, verbose){
        return axios.post(`?code=${code}&verbose=${verbose}`)
        .then(res =>{
            return res.data.status;
        })
    },
    getLogin(msisdn, gcid, verbose){
        return axios.post(`?msisdn=${msisdn}&gcid=${gcid}&verbose=${verbose}`)
        .then(res =>{
            return res.data.status;
        })
    }
}


// WEBPACK FOOTER //
// ./src/services/api/mobiscopeAPI.js